import { useState, useReducer } from "react";
import AppContext from "./AppContext";

const initialState = {
    username : '',
    utype : 0,
    ntitle : '',
    ndesc:'',
    durl:'',
    nid:'',
    cmp_copy : 0,
    wlt: 0,
    earn: 0,
    wid: 0,
    stats: [],
    noti_data:[],
    noti_row:0,
    adult_cat:0,
    perms: []
};

const reducer = (state, action) => {
    // let data = action.payload;
    switch (action.type) {
      case "userwlt":
        return {
            ...state,
            username:action.payload.username,
            email:action.payload.email,
            wlt:action.payload.wlt
        }
    case "userinfo":
            return {
                ...state,
                username:action.payload.username,
                email:action.payload.email,
        }
    case "wlt" :
        return {
            ...state,
            wlt:action.wlt
        }
    case "setprm" :
        return {
            ...state,
            perms:action.perms
        }
    case "copy" :
        return {
            ...state,
            cmp_copy:action.cmp_copy
        }
    case "notiup" :
        return {
            ...state,
            ntitle:action.ntitle,
            durl:action.durl,
            ndesc:action.ndesc,
            nid:action.nid
        }
    case "noti" :
        return {
            ...state,
            noti_data:action.data,
            noti_row:action.row
        }
    case "stats" :
        return {
            ...state,
            stats:action.stats
        }
    case "utype" :
        return {
            ...state,
            stats:action.utype
        }
    case "eroad" :
    return {
        ...state,
        adult_cat:action.adult_cat
    }
      default:
        return state;
    }
  };
  
export default function AppState(props) {

    const [sts, dispatch] = useReducer(reducer, initialState);

    // const [sts, setSts] = useState({
    //     username : '',
    //     ntitle : '',
    //     cmp_copy : 0
    // });
    return (
        <AppContext.Provider value={{sts, dispatch}}>
            {props.children}
        </AppContext.Provider>
    )
}